import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { c } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ExclusiveContentBadge } from './ExclusiveContent.js';
import { Sliders } from './Icons/index.js';
import { Checkbox } from './index.js';
export const ExclusiveContentInput = (props) => {
    const { me } = props;
    const exclusiveContent = useSelector(selectExclusiveContent);
    return (React.createElement(React.Fragment, null, me && me.details.isSystemAgent && (React.createElement("div", null,
        React.createElement(Link, { to: "/lighthouse", style: { color: 'inherit ' } },
            React.createElement(Sliders, { style: {
                    float: 'right',
                    width: '20px',
                    height: '20px',
                    marginTop: '5px',
                    cursor: 'pointer',
                }, onClick: () => {
                    c.local.toggleRightNav();
                } })),
        React.createElement(Checkbox, { checked: !!exclusiveContent?.length, onChange: () => {
                if (!exclusiveContent?.length) {
                    c.exclusiveContent.select([me.id]);
                }
                else {
                    c.exclusiveContent.select([]);
                }
            }, placeholder: React.createElement(ExclusiveContentBadge, null) })))));
};
export default ExclusiveContentInput;
//# sourceMappingURL=ExclusiveContentInput.js.map